import { Box } from '@mui/material';
import { addDays, differenceInDays, format, parseISO } from 'date-fns';
import React from 'react';
import { Bar, BarChart, CartesianGrid, Cell, Label, ResponsiveContainer, Tooltip, XAxis } from 'recharts';

interface TimelineData {
  yIndex: number;
  startDate: string;
  endDate: string;
  backgroundColor: string;
  title: string;
  icon: string;
}

interface TransformedData {
  backgroundColor: string;
  name: string;
  startDate: string;
  xOffset: number;
  yOffset: number;
  length: number;
}

interface TimelineChartProps {
  data: TimelineData[];
}

const CustomTick = (props: any) => {
  const { x, y, payload, index, data } = props;
  if (!data || data.length === 0) {
    return null;
  }
  console.log('data', data);
  const firstItem = data[0];
  return (
    <g>
      <text fontSize={20} fontWeight="bold" x={x} y={y + 20}>
        {index + 1}
      </text>
      <text stroke="#cccccc" x={x - 15} y={y + 43}>
        {format(addDays(firstItem.startDate, index), 'dd/MM')}
      </text>
    </g>
  );
};

const TimelineChart: React.FC<TimelineChartProps> = ({ data }) => {
  if (!data || data.length === 0) {
    return null;
  }
  const chartStartDate = data[0].startDate;

  const chartData: TransformedData[] = data.map((item, index) => ({
    name: item.title,
    backgroundColor: item.backgroundColor,
    yOffset: item.yIndex * 60,
    xOffset: differenceInDays(item.startDate, chartStartDate) + 25,
    length: (differenceInDays(item.endDate, item.startDate)) * 50,
    startDate: item.startDate,
  }));

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart layout="vertical" data={chartData} margin={{ top: 20, right: 0, left: 0, bottom: 70 }}>
        <XAxis
          tick={<CustomTick data={data} />}
        >
          <Label value="Custom X-Axis Label" fontWeight={"bold"} offset={-60} position="insideBottom" />
        </XAxis>
        <Bar dataKey="length" fill="#82ca9d" minPointSize={10} barSize={50}>
          {chartData.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              x={entry.xOffset}
              y={entry.yOffset}
              width={entry.length}
              radius={12}
              height={50}
              fill={entry.backgroundColor}
              stroke="#4a4a4a"
              strokeWidth={1}
              textAnchor='middle'
              textDecoration={"underline"}
              fontSize={12}
              fontWeight={"bold"}

            >

            </Cell>
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default TimelineChart;
